import React, { useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';

import EditColumnsButton from '..';
import { useModal } from '../../../hooks/use-modal';
import { fulfillmentColumns } from '../../../shipping/fulfillments/columns';
import { FulfillmentContext } from '../../../shipping/fulfillments/context';
import {
  defaultColumnConfigurationsBasic,
  defaultColumnConfigurationsWithSort,
} from '../../../store/external-fulfillments/default-column-configuration';
import { EditColumnsModal } from '../../modals/edit-columns-modal';
import { saveUserSettingGridConfig } from '../../../store/user/user.actions';
import { useEnableExtendedFulfillmentsGridSortFilter } from '../../../feature-flags/hooks/use-enable-extended-fulfillments-grid-sort-filter';
import { useSelectedShippingViewId } from '../../../pages/shipping-page/shipping-left-nav/shipping-left-nav-context';

const EditFulfillmentsGridColumnsButton = () => {
  const statusViewId = useSelectedShippingViewId();
  const isExtendedFulfillmentsGridSortFilterEnabled = useEnableExtendedFulfillmentsGridSortFilter();
  const defaultColumnConfigurations = isExtendedFulfillmentsGridSortFilterEnabled
    ? defaultColumnConfigurationsWithSort
    : defaultColumnConfigurationsBasic;
  const dispatch = useDispatch();
  const { columnConfiguration, setColumnConfiguration, activeFilterViewId } = useContext(FulfillmentContext);
  const { close, isOpen, open } = useModal();
  const onClick = useCallback(() => {
    open();
  }, [open]);
  const saveColumnConfiguration = useCallback(
    (columns) => {
      columns.forEach((column, index) => {
        // oxlint-disable-next-line no-param-reassign
        column.index = index;
      });
      dispatch(saveUserSettingGridConfig('fulfillments', statusViewId, activeFilterViewId, columns));
      setColumnConfiguration(columns);
    },
    [activeFilterViewId, statusViewId, dispatch, setColumnConfiguration],
  );

  return (
    <>
      <EditColumnsButton onClick={onClick} />
      {isOpen && (
        <EditColumnsModal
          baseColumns={fulfillmentColumns}
          columnConfiguration={columnConfiguration}
          defaultColumnConfigurations={defaultColumnConfigurations}
          onClose={close}
          saveColumnConfiguration={saveColumnConfiguration}
        />
      )}
    </>
  );
};

export default EditFulfillmentsGridColumnsButton;
